import { useMutation, useQuery } from "react-query";
import { findPaymentQR, getModuleType, uploadFile } from "../apiClient/base";

export const useUpdateProfile = (options) => {
  return useMutation((payload) => uploadFile(payload), options);
};
export const useGetModuleType = ({ payload, config }) => {
  return useQuery(["GET_MODULE_TYPE", payload], () => getModuleType(payload), config);
};

// * Display Payment QR
export const useFindPaymentQR = ({ payload, config }) => {
  return useQuery(["FIND_PAYMENT_QR", payload], () => findPaymentQR(payload), config);
};
